
import axios from 'axios';
import {APIName} from 'config';
import {useState, useEffect} from 'react';
import useAlertWithTimeout from 'hooks/useAlertWithTimeout';

export default function useDownload() {
  const [percent, setPercent] = useState(-1);
  const alertWithTimeout = useAlertWithTimeout();
  const [downloadFile, setDownloadFile] = useState('');
  const [{loading, error, message}, setStatus] = useState(false);
  const [isLinkDownloaded, setIsLinkDownloaded] = useState(false);

  useEffect(() => {
    if (isLinkDownloaded === true) {
      autoDownloadFile();
    }
  }, [isLinkDownloaded]);

  const startDownload = ({downloadPath, password = null, showErrorAlert = false}) => {
    setPercent(-1);
    setStatus({
      loading: true,
      message: ''
    });
    const fileName = downloadPath.split('/').pop();
    return axios
      .post(
        `/api/${APIName}/download`,
        password ? {
          pagePath: downloadPath,
          password,
        } : {
          pagePath: downloadPath,
        }, {
          responseType: 'blob',
          onDownloadProgress: progressEvent => {
            const eventTarget = progressEvent.event.target;
            const total = eventTarget.getResponseHeader('X-Actual-Content-Length');
            setPercent(total ? (100 * progressEvent.loaded) / total : 100);
          }
        })
      .then(response => {
        setStatus({
          loading: false,
          error: false,
          message: 'File successfully downloaded!'
        });
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        });
        const objectUrl = window.URL.createObjectURL(blob);
        setDownloadFile({url: objectUrl, fileName});
        setIsLinkDownloaded(bool => !bool);
        setTimeout(() => {
          setPercent(-1);
          setIsLinkDownloaded(bool => !bool);
        }, 3000);
      })
      .catch(async ({response}) => {
        setPercent(-1);
        setStatus({
          loading: false,
          error: true,
          message:
                  response?.status === 404
                    ? 'File not found!'
                    : response?.status === 403
                      ? 'Password is not valid!'
                      : response?.status === 500
                        ? 'Server Error!'
                        : await response?.data?.text() || ''
        });
        if(showErrorAlert) {
          response?.status === 404
            ? alertWithTimeout('File not found!', 'File not found!', 3000, 'error')
            : response?.status === 500
              ? alertWithTimeout('Server Error!', 'Server Error!', 3000, 'error')
              : alertWithTimeout('Failed to download', await response?.data?.text() || '', 3000, 'error');
        }
      });
  };

  function autoDownloadFile() {
    let a = document.createElement('a');
    a.setAttribute('href', downloadFile.url);
    a.setAttribute('download', downloadFile.fileName);
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  return {startDownload, loading, error, message, downloadFile, isLinkDownloaded, percent};
}
